import React from 'react'
import "./ContentDiv.scss"
export default function ContentDiv({className,width,fontSize,color,fontFamily,lineHeight,textAlign,marginTop,marginBottom,text}) {
  return (
    <div className={className} style={{width,fontFamily,fontSize,lineHeight,textAlign,marginTop,marginBottom,color}}>{text}</div>
  )
}
